import { combineReducers } from "@reduxjs/toolkit";
import appDetailsReducer from "./reducers/appDetailsReducer";

const rootReducer = combineReducers({
  appDetails: appDetailsReducer
});

export default rootReducer;
